import React, { useEffect, useState } from "react";
import { ReactComponent as YoutubeIcon } from "assets/icons/youtube.svg";
import { getHouseScanWeeklyVideo } from "../../../firebase/firebaseService";
import useAuth from "hooks/useAuth";

const HowDoesItWork = () => {
  const [videoLink, setVideoLink] = useState("");
  const { user } = useAuth();

  useEffect(() => {
    const fetchVideo = async () => {
      const videoRes = await getHouseScanWeeklyVideo();
      setVideoLink(videoRes);
    };

    fetchVideo();
  }, [user]);

  return (
    <div className="bg-white w-full lg:w-[56%] h-[335px] sm:h-[450px] md:h-[552px] rounded-[15px] px-[15px] sm:px-[20px] pb-5 sm:pb-[23px] pt-[20px] ">
      <div className="flex items-center space-x-[15px]">
        <div className="bg-[#E8F6FF] flex-shrink-0 w-[52px] h-[52px] rounded-full flex items-center justify-center">
          <YoutubeIcon />
        </div>
        <h1 className="text-[16px] md:text-[22px] font-semibold leading-[19.36px] md:leading-[30px] text-black max-w-[406px] line-clamp-3">
          La Pillola Settimanale di{" "}
          <span className="text-primary"> HouseScan!</span>
        </h1>
      </div>
      <hr className="h-[1px] bg-[#D7D7D7] mt-[21px] " />
      <div className="h-[calc(100%-90px)] md:h-[calc(100%-125px)] box-content mt-4 sm:mt-5 md:mt-[36px] rounded-[5px] relative">
        {videoLink && (
          <iframe
            width="100%"
            height="100%"
            className="rounded-[5px]"
            src={videoLink}
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          ></iframe>
        )}
      </div>
    </div>
  );
};

export default HowDoesItWork;
